const API_URL = process.env.REACT_APP_BACKEND_URL;

function detailMessage(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || JSON.stringify(item)).join(" ");
  if (detail.message) return detail.message;
  if (detail.error?.message) return detail.error.message;
  return String(detail);
}

function csrfToken() {
  if (typeof document === "undefined") return "";
  return document.cookie.split(";").map((part) => part.trim()).find((part) => part.startsWith("customer_csrf_token="))?.split("=").slice(1).join("=") || "";
}

function adminCsrfToken() {
  if (typeof document === "undefined") return "";
  return document.cookie.split(";").map((part) => part.trim()).find((part) => part.startsWith("admin_csrf_token="))?.split("=").slice(1).join("=") || "";
}

async function request(path, options = {}) {
  const csrf = csrfToken();
  const adminCsrf = adminCsrfToken();
  const response = await fetch(`${API_URL}/api${path}`, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...(csrf ? { "X-CSRF-Token": csrf } : {}), ...(adminCsrf ? { "X-Admin-CSRF-Token": adminCsrf } : {}), ...(options.headers || {}) },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(detailMessage(body.detail));
    error.status = response.status;
    throw error;
  }
  return body;
}

export function getCustomerDomains() {
  return request("/customer/domains");
}

export function createCustomerDomain(siteId, domain, canonical) {
  return request("/customer/domains", { method: "POST", body: JSON.stringify({ siteId, domain, canonical }) });
}

export function checkCustomerDomain(connectionId) {
  return request(`/customer/domains/${connectionId}/check`, { method: "POST" });
}

export function selectCustomerDomainMethod(connectionId, method) {
  return request(`/customer/domains/${connectionId}/method`, { method: "POST", body: JSON.stringify({ method }) });
}

export function confirmCustomerDomainPlan(connectionId, confirmed, planId) {
  return request(`/customer/domains/${connectionId}/confirm-plan`, { method: "POST", body: JSON.stringify({ confirmed, planId }) });
}

export function getCustomerDomainHistory(connectionId) {
  return request(`/customer/domains/${connectionId}/history`);
}

export function getCloudflareStatus() {
  return request("/cloudflare/status");
}

export function getCloudflareZones(connectionId) {
  return request(`/cloudflare/zones?connectionId=${encodeURIComponent(connectionId)}`);
}

export function selectCloudflareZone(connectionId, zoneId) {
  return request("/cloudflare/zones/select", { method: "POST", body: JSON.stringify({ connectionId, zoneId }) });
}

export async function startCloudflareAuthorization(connectionId) {
  return request(`/cloudflare/oauth/start?connectionId=${encodeURIComponent(connectionId)}`);
}

export function getAdminDomainConnections() {
  return request("/admin/domains");
}

export function getAdminDomainAnalytics() {
  return request("/admin/domains/analytics");
}

export function getAdminDomainInvites() {
  return request("/admin/domains/invites");
}

export function createCustomerInvite(siteId, email, name) {
  return request("/admin/domains/invites", { method: "POST", body: JSON.stringify({ siteId, email, name }) });
}

export function recheckAdminDomain(connectionId) {
  return request(`/admin/domains/${connectionId}/recheck`, { method: "POST" });
}

export function getAdminDomainHistory(connectionId) {
  return request(`/admin/domains/${connectionId}/history`);
}
